<template>
<div class="dhivehi">
  <xui-select
      :disabled='disabled'
      class=""
      :label="label"
      :hasSearch="hasSearch || false" 
      :placeholder="placeholder || 'Select...'"
      :options="items"
      :keys="{id: optionKey, label:  optionLabel}"
      v-model="selectedItem"
      @input="updateValue"
      :type="type || 'basic'"
  ></xui-select>
  <div v-for="error in myErrors" :key="error">{{error}}</div>
</div>
</template>

<script>

import UiSelect from '@/components/util/new_select/UiSelect.vue'

export default {
  name: 'NewSelect',
  data () {
    return {
      items: [],
      selectedItem: {},
      myErrors: [],
      myLabel: ''
    }
  },

  components: {
    'xui-select': UiSelect
  },

  props: [
    'label',
    'value',
    'url',
    'placeholder',
    'optionLabel',
    'optionKey',
    'options',
    'type',
    'disabled',
    'hasSearch',
    'mode'
  ],



  computed: {
  },

  methods: {
    loadOptions() {
        let url = (typeof this.url == 'function') ?
                    this.url() :
                        this.url;
                    
      axios.get(url).then((resp) => {
        this.items = resp.data
      }) 
    },

    updateValue(value) {
      if(this.mode === 'object') {
        this.$emit('input', value)
      } else {
        this.$emit('input', value[this.optionKey])
      }
      // this.$emit('input', value[this.optionKey])
    },

    updateValueFromParent(newValue) {

      // TODO:: refactor selctedItems to be a computed item with setter and getter
      // and remove watch for items and options ?
      if(this.mode === 'object') {
        this.selectedItem = this.value
      } else {
      if(this.items) {
        this.selectedItem = this.items.find(item => item[this.optionKey] == newValue) || {}  
      } else {
        this.selectedItem = {}
      }
      }
      
    },

    updateOptionsFromParent(newValue) {
      this.items = newValue || []
    }
    

  },
  watch: {
    value: function(newValue, oldValue) {
      this.updateValueFromParent(newValue)
    },
    options: function(newValue, oldValue) {
      this.updateOptionsFromParent(newValue)
    },
    items:function() {
      this.updateValueFromParent(this.value)
    }
  },
  created() {
   
    this.updateOptionsFromParent(this.options)
    this.updateValueFromParent(this.value)
    if(this.url) {
      this.loadOptions()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .ui-select-option__basic {
        white-space: normal !important;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .ui-select:not(.is-multiple) .ui-select__display {
    height: auto;
    line-height: initial;
}
.error {
  color: red;
}

.report-form {
  height: 50vh;
}

.actions {
  display: flex;
  align-content: center;
}
</style>
